import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// types
type ConfirmDialogProps = {
    agreeButtonDisplay: string,
    body: string | JSX.Element,
    handleClickAgree: () => void,
    handleClickDisagree: () => void,
    isOpen: boolean,
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
    title: string,
}

export default function ConfirmDialog(props: ConfirmDialogProps) {
    const {
        agreeButtonDisplay,
        body,
        handleClickAgree,
        handleClickDisagree,
        isOpen,
        setIsOpen,
        title,
    } = props;

    return (
        <div>
            <Dialog
                open={isOpen}
                onClose={() => setIsOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {body}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        handleClickDisagree();
                        setIsOpen(false);
                    }}>
                        キャンセル
                    </Button>
                    <Button onClick={() => {
                        handleClickAgree();
                        setIsOpen(false);
                    }} autoFocus>
                        {agreeButtonDisplay}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}